"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useRef, useCallback, Suspense } from "react";
import { useSearchParams } from "next/navigation";
import SearchBar from "../components/SearchBar";
import GifGrid from "../components/GifGrid";
import Toast from "../components/Toast";
import { useGifSearch } from "../hooks/useGifSearch";
import { useToast } from "../hooks/useToast";
import styles from "./page.module.css";
function HomePageContent() {
  const $ = _c(42);
  const searchParams = useSearchParams();
  let t0;
  if ($[0] !== searchParams) {
    t0 = searchParams.get("q") || "";
    $[0] = searchParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const urlQuery = t0;
  const {
    gifs,
    loading,
    error,
    hasMore,
    searchGifs,
    loadMore,
    loadInitialGifs
  } = useGifSearch();
  const {
    message,
    isVisible,
    show: showToast
  } = useToast();
  const hasInitialized = useRef(false);
  let t1;
  let t2;
  if ($[2] !== loadInitialGifs || $[3] !== urlQuery) {
    t1 = () => {
      if (!hasInitialized.current) {
        hasInitialized.current = true;
        if (!urlQuery.trim()) {
          loadInitialGifs();
        }
      }
    };
    t2 = [loadInitialGifs, urlQuery];
    $[2] = loadInitialGifs;
    $[3] = urlQuery;
    $[4] = t1;
    $[5] = t2;
  } else {
    t1 = $[4];
    t2 = $[5];
  }
  useEffect(t1, t2);
  let t3;
  if ($[6] !== loadInitialGifs || $[7] !== searchGifs) {
    t3 = query => {
      if (query.trim()) {
        searchGifs(query.trim());
      } else {
        loadInitialGifs();
      }
    };
    $[6] = loadInitialGifs;
    $[7] = searchGifs;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const handleSearch = t3;
  let t4;
  if ($[9] !== showToast) {
    t4 = () => {
      showToast("URL Copied to Clipboard");
    };
    $[9] = showToast;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const handleCopy = t4;
  let t5;
  if ($[11] !== loadMore) {
    t5 = () => {
      loadMore();
    };
    $[11] = loadMore;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const handleLoadMore = t5;
  let t6;
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <h1>GIF Picker</h1>;
    t7 = <p className="subtitle">Search and share GIFs from GIPHY</p>;
    $[13] = t6;
    $[14] = t7;
  } else {
    t6 = $[13];
    t7 = $[14];
  }
  let t8;
  if ($[15] !== handleSearch) {
    t8 = <header className={styles.header}>{t6}{t7}<SearchBar onSearch={handleSearch} /></header>;
    $[15] = handleSearch;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== error) {
    t9 = error && <div className="empty" role="alert">{(error.toLowerCase().includes("rate limit") || error.toLowerCase().includes("429")) && <video className={styles.errorImage} src="/mad-cat.mp4" width={200} height={200} autoPlay={true} loop={true} muted={true} playsInline={true} />}<h3>{error.toLowerCase().includes("rate limit") || error.toLowerCase().includes("429") ? "Please try again later" : "Error"}</h3><p>{error}</p></div>;
    $[17] = error;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== gifs.length || $[20] !== loading) {
    t10 = loading && gifs.length === 0 && <div className={styles.loading}><div className="spinner" /><p>Loading GIFs...</p></div>;
    $[19] = gifs.length;
    $[20] = loading;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== error || $[23] !== gifs.length || $[24] !== loading) {
    t11 = !loading && gifs.length === 0 && !error && <div className="empty" role="status"><video className={styles.errorImage} src="/sad-cat.mp4" width={200} height={200} autoPlay={true} loop={true} muted={true} playsInline={true} /><h3>No GIFs found</h3><p>Try a different search</p></div>;
    $[22] = error;
    $[23] = gifs.length;
    $[24] = loading;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== gifs || $[27] !== handleCopy || $[28] !== handleLoadMore || $[29] !== hasMore || $[30] !== loading) {
    t12 = gifs.length > 0 && <><GifGrid gifs={gifs} onCopy={handleCopy} />{hasMore && <button onClick={handleLoadMore} disabled={loading} className="loadMore">{loading ? "Loading..." : "Load More"}</button>}{loading && gifs.length > 0 && <div className={styles.loadingMore}><div className="spinner" /><span>Loading GIFs...</span></div>}</>;
    $[26] = gifs;
    $[27] = handleCopy;
    $[28] = handleLoadMore;
    $[29] = hasMore;
    $[30] = loading;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  let t13;
  if ($[32] !== isVisible || $[33] !== message) {
    t13 = <Toast message={message} isVisible={isVisible} />;
    $[32] = isVisible;
    $[33] = message;
    $[34] = t13;
  } else {
    t13 = $[34];
  }
  let t14;
  if ($[35] !== t10 || $[36] !== t11 || $[37] !== t12 || $[38] !== t13 || $[39] !== t8 || $[40] !== t9) {
    t14 = <main className={styles.main}>{t8}{t9}{t10}{t11}{t12}{t13}</main>;
    $[35] = t10;
    $[36] = t11;
    $[37] = t12;
    $[38] = t13;
    $[39] = t8;
    $[40] = t9;
    $[41] = t14;
  } else {
    t14 = $[41];
  }
  return t14;
}
export default function HomePage() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <header className={styles.header}><h1>GIF Picker</h1><p className="subtitle">Search and share GIFs from GIPHY</p></header>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Suspense fallback={<main className={styles.main}>{t0}<div className={styles.loading}><div className="spinner" /><p>Loading...</p></div></main>}><HomePageContent /></Suspense>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}